import React, {useState} from "../../../_snowpack/pkg/react.js";
import {CheckboxGroup, CheckboxButton, Button} from "../../../_snowpack/pkg/@ferpection/uikit.js";
function getSolutionsFromSelectedGoals(goals, selectedIndexes) {
  let max = 0;
  const weightObject = goals.filter((_, index) => selectedIndexes.map(Number).includes(index)).map((goal) => goal.solutions).reduce((aggr, curr) => {
    for (const c of curr) {
      aggr[c] = (aggr[c] ?? 0) + 1;
    }
    return aggr;
  }, {});
  const weights = Object.entries(weightObject);
  for (const [, weight] of weights) {
    if (weight > max) {
      max = weight;
    }
  }
  return weights.filter(([, weight]) => weight === max).map(([name]) => name);
}
const Goals = ({step, lang}) => {
  const [selectedGoalIndexes, setSelectedGoalIndexes] = useState([]);
  const selectedSolutions = getSolutionsFromSelectedGoals(step.goals, selectedGoalIndexes);
  const bestSolutionURL = `/${lang}/${selectedSolutions[0] ?? ""}/`;
  function isCompatible(solutions = []) {
    if (selectedGoalIndexes.length < 1)
      return true;
    for (const solution of solutions) {
      if (!selectedSolutions.includes(solution)) {
        continue;
      }
      return true;
    }
    return false;
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: "Goals"
  }, lang === "fr" && /* @__PURE__ */ React.createElement("a", {
    className: "back-link",
    href: "/fr/choisir-methodologie/"
  }, /* @__PURE__ */ React.createElement("i", {
    class: "fa fa-chevron-left"
  }), "Changer mon choix d'étape"), lang === "en" && /* @__PURE__ */ React.createElement("a", {
    className: "back-link",
    href: "/en/choose-method/"
  }, /* @__PURE__ */ React.createElement("i", {
    class: "fa fa-chevron-left"
  }), "Change project stage"), lang === "fr" && (selectedGoalIndexes.length < 1 ? /* @__PURE__ */ React.createElement("h1", {
    className: "assistant-title"
  }, "Choisissez votre objectif principal") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h1", {
    className: "assistant-title"
  }, "Avez-vous d'autres objectifs ?"), /* @__PURE__ */ React.createElement("p", {
    className: "description"
  }, "Les objectifs grisés ne sont pas compatible avec celui choisi, ils necessitent une étude à part."))), lang === "en" && (selectedGoalIndexes.length < 1 ? /* @__PURE__ */ React.createElement("h1", {
    className: "assistant-title"
  }, "Choose your main goal") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h1", {
    className: "assistant-title"
  }, "Do you have other goals?"), /* @__PURE__ */ React.createElement("p", {
    className: "description"
  }, "The shaded goals are not compatible with the one chosen, they require a separate study."))), /* @__PURE__ */ React.createElement("div", {
    className: "goals"
  }, /* @__PURE__ */ React.createElement(CheckboxGroup, {
    value: selectedGoalIndexes,
    onValueChange: setSelectedGoalIndexes
  }, step.goals.map((goal, index) => {
    return /* @__PURE__ */ React.createElement(CheckboxButton, {
      key: index,
      value: `${index}`,
      isDisabled: !isCompatible(goal.solutions) && !selectedGoalIndexes.includes(String(index))
    }, goal.title);
  })), /* @__PURE__ */ React.createElement("div", {
    className: "actions"
  }, lang === "fr" && /* @__PURE__ */ React.createElement(Button, {
    onClick: () => location.assign(bestSolutionURL),
    isDisabled: selectedSolutions.length !== 1,
    isFilled: true
  }, "Découvrir la méthodologie adaptée"), lang === "en" && /* @__PURE__ */ React.createElement(Button, {
    onClick: () => location.assign(bestSolutionURL),
    isDisabled: selectedSolutions.length !== 1,
    isFilled: true
  }, "Discover the adapted methodology"))));
};
export default Goals;
